import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';

interface Props {
  lang: 'en' | 'ru' | 'it' | 'fr';
}

export default function Projects({ lang }: Props) {
  const { t } = useTranslation('projects');
  const tc = useTranslation('common').t;

  return (
    <Layout lang={lang}>
      <div className="blog-post">
        <h2 className="blog-post-title">{t('title')}</h2>
        <p className="blog-post-meta">
          {t('date')} &nbsp;|&nbsp; <Link to={lang === 'en' ? '/' : `/${lang}`}>{tc('mainPage')}</Link>
          &nbsp;|&nbsp; <a href="https://github.com/microbusiness" target="_blank" rel="noopener noreferrer">{tc('github')}</a>
        </p>
        <hr />

        <p>{t('intro')}</p>

        <h3>{t('pegast.title')}</h3>
        <p>
          <a href="https://pegast.ru" target="_blank" rel="noopener noreferrer">
            <img
              src="https://pegast.ru/static/frontend/layout/images/logo.svg"
              alt="Pegast"
              style={{ maxHeight: '60px', marginBottom: '10px' }}
            />
          </a>
        </p>
        <p>{t('pegast.text')}</p>

        <h3>{t('aviator.title')}</h3>
        <p>
          <a href="https://aviator.pegast.su" target="_blank" rel="noopener noreferrer">
            <img
              src="https://63900.selcdn.ru/iv/portfolio/aviator_main.png"
              alt="Aviator"
              style={{ maxWidth: '100%', marginBottom: '10px' }}
            />
          </a>
        </p>
        <p>{t('aviator.text')}</p>

        <h3>{t('fabio.title')}</h3>
        <p>{t('fabio.text')}</p>
        <ul>
          <li><strong>Front:</strong> {t('fabio.front')}</li>
          <li><strong>Backend:</strong> {t('fabio.backend')}</li>
          <li><strong>Images:</strong> {t('fabio.images')}</li>
        </ul>
        <p>{t('fabio.extra')}</p>

        <h3>{t('cotrip.title')}</h3>
        <p>
          <a href="https://cotrip.ru" target="_blank" rel="noopener noreferrer">
            <img
              src="https://63900.selcdn.ru/iv/portfolio/mainpic.jpg"
              alt="Cotrip"
              style={{ maxWidth: '100%', marginBottom: '10px' }}
            />
          </a>
        </p>
        <p>{t('cotrip.text')}</p>
        <ul>
          <li><strong>Front:</strong> {t('cotrip.front')}</li>
          <li><strong>Backend:</strong> {t('cotrip.backend')}</li>
          <li><strong>Images:</strong> {t('cotrip.images')}</li>
          <li><strong>Geo:</strong> {t('cotrip.geo')}</li>
          <li><strong>Payment:</strong> {t('cotrip.payment')}</li>
        </ul>

        <hr />
        <p>{t('footer')}</p>

        <h4>{t('summary.title')}</h4>
        <p>{t('summary.text')}</p>
        <ul>
          <li><a href="https://pegast.ru" target="_blank" rel="noopener noreferrer">pegast.ru</a> — {t('summary.pegast')}</li>
          <li><a href="https://aviator.pegast.su" target="_blank" rel="noopener noreferrer">aviator.pegast.su</a> — {t('summary.aviator')}</li>
          <li>fabiohome.ru — {t('summary.fabio')}</li>
          <li><a href="https://cotrip.ru" target="_blank" rel="noopener noreferrer">cotrip.ru</a> — {t('summary.cotrip')}</li>
        </ul>
      </div>
    </Layout>
  );
}
